import { render } from "./browserNotSupported.vue?vue&type=template&id=678359b4&ts=true"
import script from "./browserNotSupported.ts?vue&type=script&lang=ts"
export * from "./browserNotSupported.ts?vue&type=script&lang=ts"

import "./browserNotSupported.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__